export default "__VITE_ASSET__BWONtkBI__"